import { render, staticRenderFns } from "./UserFormSubmitted.vue?vue&type=template&id=a52fff52&scoped=true&"
import script from "./UserFormSubmitted.vue?vue&type=script&lang=js&"
export * from "./UserFormSubmitted.vue?vue&type=script&lang=js&"
import style0 from "./UserFormSubmitted.vue?vue&type=style&index=0&id=a52fff52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a52fff52",
  null
  
)

export default component.exports